import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/Header";

import { fetchProjects } from "../../api/project";

export default function SelectProject() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [activeImage, setActiveImage] = useState("/images/default_project.png");
  const user = JSON.parse(localStorage.getItem("user"));
  const isSuperuser = user?.is_superuser;

  useEffect(() => {
    // 1. API로 최신 목록 조회
    fetchProjects()
      .then((res) => {
        const freshList = res.data.projects || [];
        setProjects(freshList);
        // localStorage 업데이트 (캐시용)
        localStorage.setItem("projects", JSON.stringify(freshList));
      })
      .catch((err) => {
        console.error("Failed to fetch projects:", err);
        // 실패 시 로컬 스토리지 폴백
        const cached = JSON.parse(localStorage.getItem("projects")) || [];
        setProjects(cached);
      });
  }, []);

  // (주석 삭제 금지) 이미지 위치는 public/images/projects/ 안에 모두 저장되도록 해주세요
  // png가 아니라 jpeg, jpg 등이 들어오는 경우에는 if문 분기가 필요합니다 추후 필요하면 작성하시면 될 것 같습니다!
  const getProjectImage = (proj) => {
      if (proj.image) return proj.image;
      return `/images/projects/${proj.id}.png`;
  };

  // 계산된 height 비율
  const itemHeight = useMemo(() => {
    const total = projects.length + 1;
    return `calc(100% / ${total})`;
  }, [projects]);

  const handleSelect = (projectId) => {
    localStorage.setItem("projectId", projectId);
    navigate(`/project/${projectId}`);
  };

  return (
    <>
      <div className="w-full h-screen flex flex-col">
        <Header />

        {/* 콘텐츠 영역 */}
        <div
          className="
      flex-1 flex 
      flex-col md:flex-row // 좁으면 세로, 넓으면 가로
      overflow-hidden
    "
        >
          {/* 좌측: 이미지 */}
          <div className="flex-1 h-[50vh] md:h-full relative overflow-hidden">
            {/* 모바일에서는 높이 50vh, 데스크탑에서는 자동 */}
            <img
              src={activeImage}
              alt="selected preview"
              className="w-full h-full object-cover transition-all duration-500"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/default_project.png";
              }}
            />

            <div
              style={{
                position: "absolute",
                bottom: "25px",
                width: "100%",
                textAlign: "center",
                color: "rgba(255,255,255,0.7)",
                fontSize: "12px",
                placeItems: "center",
              }}
            >
              <span>
                Copyright ⓒ by <b>P6ix S</b>mart <b>C</b>onstruction Co., Ltd.
                ALL RIGHTS RESERVED
              </span>
            </div>
          </div>

          {/* 우측: 리스트 */}
          <div
            className="
        w-full md:w-[300px]   // 모바일에서는 전체폭, 데스크탑에서는 고정폭
        h-[50vh] md:h-full    // 모바일에서는 절반 높이, 데스크탑에서는 전체 높이
        border-t md:border-t-0 md:border-l 
        bg-white flex flex-col
      "
          >
            {projects.map((proj) => (
              <div
                key={proj.id}
                className="flex items-center justify-center border-b cursor-pointer select-none
                     hover:bg-gray-50 transition"
                style={{ height: itemHeight }}
                onMouseEnter={() => setActiveImage(getProjectImage(proj))}
                onMouseLeave={() =>
                  setActiveImage("/images/default_project.png")
                }
                onClick={() => handleSelect(proj.id)}
              >
                <div className="text-center">
                  <div className="text-lg font-semibold">{proj.name}</div>
                  <div className="text-xs text-gray-500">
                    Project ID: {proj.id}
                  </div>
                </div>
              </div>
            ))}

            {isSuperuser && (
              <div
                className="flex items-center justify-center cursor-pointer hover:bg-gray-50 border-t"
                style={{ height: itemHeight }}
                onClick={() => navigate("/create-project")}
              >
                <div className="flex flex-col items-center">
                  <div className="w-14 h-14 border-2 border-gray-700 rounded-full flex items-center justify-center">
                    <span className="text-4xl leading-none text-gray-700">
                      +
                    </span>
                  </div>
                  <span className="text-sm mt-2 text-gray-600">
                    New Project
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
